module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/bmwtypewebbo_all.svg?7c9d6430455b5010fb513edbce3e149d";